export default __webpack_public_path__ + "maps-examples-dds-circle-layer-thumbnail-960-bdbe77293401b476b6d46faef05e5346.webp";